// 引入axios 实例
import request from "@/utils/request";
import qs from "qs";
//学校列表
export const overviewgetSchoolList = (data) => {
  return request({
    url: "/api/overview/getSchoolList",
    method: "post",
    params: data,
  });
};

//院系列表
export const overviewgetFacultyList = (data) => {
  return request({
    url: "/api/overview/getFacultyList",
    method: "post",
    params: data,
  });
};
//数据总览
export const overviewgetStatistics = (data) => {
  return request({
    url: "/api/overview/getStatistics",
    method: "post",
    data: data,
  });
};
//资源建设--题库总量
export const resourcesBuildgetQuesCount = (data) => {
  return request({
    url: "/api/resourcesBuild/getQuesCount",
    method: "post",
    data: data,
  });
};
//资源建设--资源统计
export const resourcesBuildgetResourcesCount = (data) => {
  return request({
    url: "/api/resourcesBuild/getResourcesCount",
    method: "post",
    data: data,
  });
};
//签到概况
export const signCheckgetSignStatistics = (data) => {
  return request({
    url: "/api/signCheck/getSignStatistics",
    method: "post",
    data: data,
  });
};


//课堂活动
export const faceTeachgetStatistics = (data) => {
  return request({
    url: "/api/faceTeach/getStatistics",
    method: "post",
    data: data,
  });
};
//教学活跃
export const teacherStudentgetAllStatistics = (data) => {
  return request({
    url: "/api/teacherStudent/getAllStatistics",
    method: "post",
    data: data,
  });
};
//获取课程列表--签到监测
export const signCheckgetCourseList = (data) => {
  return request({
    url: "/api/signCheck/getCourseList",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
//获取课程列表--课堂活动
export const faceTeachgetCourseList = (data) => {
  return request({
    url: "/api/faceTeach/getCourseList",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
//获取教师列表--课堂活动
export const faceTeachgetTeacherList = (data) => {
  return request({
    url: "/api/faceTeach/getTeacherList",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
//获取活动列表
export const faceTeachgetActivityDetail = (data) => {
  return request({
    url: "/api/faceTeach/getActivityDetail",
    method: "post",
    data: data,

  });
};

//获取班级列表
export const signCheckgetClassList = (data) => {
  return request({
    url: "/api/signCheck/getClassList",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

//今日签到列表
export const signChecktodaySignDetailList = (data) => {
  return request({
    url: "/api/signCheck/todaySignDetailList",
    method: "post",
    data: data,
  });
};
//导出今日签到列表
export const exportTodaySignDetailList = (data) => {
  return request({
    url: "/api/signCheck/exportTodaySignDetailList",
    method: "post",
    data: data,
    responseType: "blob",
    
  });
};
//导出今日签到学生列表
export const exportSignDetailBySignId = (data) => {
  return request({
    url: "/api/signCheck/exportSignDetailBySignId",
    method: "post",
    data: data,
    responseType: "blob",
      headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
//获取某个班级学生签到详情
export const signCheckgetSignDetailBySignId = (data) => {
  return request({
    url: "/api/signCheck/getSignDetailBySignId",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
//导出课堂活动详情列表
export const faceTeachexportActivityDetail = (data) => {
  return request({
    url: "/api/faceTeach/exportActivityDetail",
    method: "post",
    data: data,
    responseType: "blob",
  });
};

